export default __webpack_public_path__ + "static/media/CNo.85-2.ff9d50ab.jpg";